import {
  Box,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";

function ClearableTextField({ value, onChange, onClear, startAdornment, ...rest }) {
  return (
    <TextField
      {...rest}
      value={value}
      onChange={onChange}
      InputProps={{
        startAdornment: startAdornment && !value ? (
          <InputAdornment position="start">{startAdornment}</InputAdornment>
        ) : undefined,
        endAdornment: value ? (
          <InputAdornment position="end">
            <IconButton
              size="small"
              onClick={onClear}
              edge="end"
              aria-label="Limpiar filtro"
              sx={{ color: "neutral.500", "&:hover": { color: "primary.900" } }}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ) : undefined,
      }}
    />
  );
}

export default function LienzoFilters({ filters, onChange, dateError, compact = false }) {
  const setFilter = (key, value) => onChange({ ...filters, [key]: value });
  const compactTextSx = compact
    ? {
        "& .MuiInputBase-input": { fontSize: 12 },
        "& .MuiInputLabel-root": { fontSize: 12 },
      }
    : {};

  return (
    <Box>
      <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
        <ClearableTextField
          size="small"
          placeholder="Buscar por período..."
          value={filters.search}
          onChange={(event) => setFilter("search", event.target.value)}
          onClear={() => setFilter("search", "")}
          startAdornment={<SearchIcon sx={{ color: "neutral.500" }} />}
          sx={{
            flex: 1,
            ...compactTextSx,
            "& .MuiOutlinedInput-root": { borderRadius: "16px" },
          }}
        />

        <ClearableTextField
          size="small"
          label="Desde"
          type="date"
          InputLabelProps={{ shrink: true }}
          value={filters.dateFrom}
          onChange={(event) => setFilter("dateFrom", event.target.value)}
          onClear={() => setFilter("dateFrom", "")}
          error={Boolean(dateError)}
          sx={{
            width: { xs: "100%", md: 180 },
            ...compactTextSx,
            "& .MuiOutlinedInput-root": { borderRadius: "16px" },
          }}
        />

        <ClearableTextField
          size="small"
          label="Hasta"
          type="date"
          InputLabelProps={{ shrink: true }}
          value={filters.dateTo}
          onChange={(event) => setFilter("dateTo", event.target.value)}
          onClear={() => setFilter("dateTo", "")}
          error={Boolean(dateError)}
          sx={{
            width: { xs: "100%", md: 180 },
            ...compactTextSx,
            "& .MuiOutlinedInput-root": { borderRadius: "16px" },
          }}
        />
      </Stack>

      {dateError ? (
        <Typography sx={{ mt: 1, fontSize: 12.5, fontWeight: 700, color: "error.main" }}>
          {dateError}
        </Typography>
      ) : null}
    </Box>
  );
}
